import React, { Fragment } from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Divider, styled, Typography } from "@mui/material";


const StyledHeadLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 14,
});

const StyledPaper = styled("div")({
  border: "none",
  display: "flex",
  alignItems: "flex-start",
  marginBottom: 16,
});

const StyledDivider = styled(Divider)({
  marginTop: 0,
  marginBottom: 16,
  borderWidth: "0px 0px thin",
  borderColor: "#919eab52",
  borderStyle: "dashed",
  width: "100%",
});

const StyledWrapHead = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

const ExpertiseTab = () => {
  const { result: userProfile } = useSelector((state) => state.userProfile);
  return (
    <div>
      <StyledWrapHead>
        <StyledHeadLabel style={{ marginBottom: 16 }}>
          {`ประวัติการศึกษา`}
        </StyledHeadLabel>
      </StyledWrapHead>

      {userProfile && userProfile.educations.length > 0 ? (
        userProfile.educations.map((education) => (
          <Fragment>
            <StyledPaper>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                }}
              >
                {/* <div style={{ position: "absolute", right: "0", top: "0" }}>
                  <ButtonBlue
                    size="small"
                    startIcon={<EditIcon />}
                    style={{ marginRight: "5px" }}
                    disabled
                    //onClick={() => handleOpenEducation("Edit",education.idEducations)}
                  >
                    แก้ไข
                  </ButtonBlue>
                  <ButtonBlue
                    size="small"
                    startIcon={<DeleteIcon />}
                    style={{ color: "red" }}
                    disabled
                    //onClick={() => handleDeleteEducation(education.idEducations)}
                  >
                    ลบ
                  </ButtonBlue>
                </div> */}
                <Typography
                  variant="h6"
                  style={{ width: "calc(100% - 143px)" }}
                >
                  {`(${
                    education.fromYear
                      ? dayjs(`01-01-${education.fromYear}`).format("BBBB")
                      : "-"
                  } ถึง ${
                    education.endYear
                      ? dayjs(`01-01-${education.endYear}`).format("BBBB")
                      : "ไม่ระบุ"
                  }) ${
                    education.university
                      ? education.university
                      : "ไม่ระบุสถานศึกษา"
                  }`}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {`สาขา ${education.major ? education.major : "ไม่ระบุ"}, คณะ ${
                    education.faculty ? education.faculty : "ไม่ระบุ"
                  }, ระดับ ${education.degree}`}
                </Typography>
                <Typography style={{ fontWeight: 700, marginTop: 8 }}>
                  {`เกรดเฉลี่ย: ${education.gpa ? education.gpa : "ไม่ระบุ"}`}
                </Typography>
              </div>
            </StyledPaper>
            <StyledDivider />
          </Fragment>
        ))
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" style={{ color: "grey" }}>
            ไม่มีข้อมูลประวัติการศึกษา
          </Typography>
        </div>
      )}
    </div>
  );
};

export default ExpertiseTab;
